import { useDropzone } from "react-dropzone";
import { Label, ToolTipV1, Note } from "lib";
import { useState, useEffect, useCallback } from "react";
import "./index.scss";
import ImageUpload from "../../assets/images/image_upload.svg";
import Image from "../Image";
import { useDispatch } from "react-redux";
import {
  uploadUserDocument,
  removeUserDocument,
  previewUploadedDocument,
} from "api/formDisplay";
import ErrorMessage from "lib/ErrorMessage";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  deleteUploadedDocument,
  setDocuments,
  setFetchedDocument,
  setUploadedDocument,
  setdeleteDocument,
} from "redux/uploadDocumentReducer";
import {
  setConfigLoading,
  setConfigLoadingText,
  setUploadLoading,
} from "redux/configurationReducer";
import {
  setMandatoryExtraction,
  clearSelectedDataKey,
} from "redux/formDisplay";
import LoadingSpinner from "lib/LoadingSpinner";
import LivenessCheck from "./livenessCheck";

import { setdeleteRecursiveDocument } from "redux/recursiveReducer";
import VideoProgress from "./videoProgress";
const Liveness = (props) => {
  const {
    label,
    enum: enums,
    tooltip,
    tooltipText,
    name,
    error,
    formErr,
    setFormErr,
    capture,
    clearFieldError,
    selectedData,
    size,
    setSelectedData,
    isEditable,
    // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
    verify,
    autofill,
    is_disabled,
    doc_type,
    service_type,
    extraction_required,
    validators,
    maxSize,
    isDisabLed,
    masking_required,
    isUserInitiated,
    isRecursive,
    doc_number_validation,
    digilocker,
    liveness,
    user_action,
    random_generate
  } = props;

  const [uploaded, setUploaded] = useState(false);
  const [fileName, setFileName] = useState();
  const [fileSize, setFileSize] = useState();
  // const [image, setImage] = useState(capture)
  const [invalidError, setInvalidError] = useState("");
  const [messageToast, setMessageToast] = useState({ type: "", msg: "" });
  const [isUploading, setIsUploading] = useState(false);
  const [orcMessage, setOcrMessage] = useState("");

  const isAutofilled = useSelector(
    (state) => state.uploadDocumentReducer?.isAutofilled
  );
  const [newName, setName] = useState(`${name}`);
  const recursive = useSelector((state) => state?.recursive);
  const documents = useSelector(
    (state) => state.uploadDocumentReducer?.documents
  );
  const uploadedDocuments = useSelector(
    (state) => state.uploadDocumentReducer?.uploadedDocument
  );
  const isToggled = useSelector((state) => state.formData.isToggled);
  const copiedData = useSelector((state) => state.formData.copiedData);
  const organisationId = useSelector(
    (state) => state.configurationReducer.config?.organisation_id
  );
  const dispatch = useDispatch();
  const params = useParams();
  const decryptedId = useSelector((state) => state.urlEncryption?.urlId);
  const subWfId = useSelector(
    (state) => state.dashboardDetailReducer?.currentSubWorkFlowId
  );
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const customerInfo = useSelector((state) => state.userInfo);
  const verificationResponses = useSelector(
    (state) => state.uploadDocumentReducer
  );
  const subworkflows = useSelector(
    (state) => state.userInfo.workflowUser.subworkflows
  );

  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const userInfo = {
    userId: decryptedId.userId,
    primaryWorkflowId: decryptedId.primaryWorkflowId,
    // subWfId: decryptedId.subWfId,
    organisationId,
  };
  const docType = doc_type?.toLowerCase() || "document";
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: enums,
    maxSize: maxSize,
    // when I drag and drop a file which is not supported by the enums, I want to show an error message to the user and not upload the file
    onDropAccepted: (acceptedFiles, rejectedFiles) => {
      const acceptedFile = acceptedFiles.map((file) => {
        let fileData = {
          file: file,
          file_path: file.path,
          file_size: file.size,
        };
        return fileData;
      });
      clearFieldError && clearFieldError(name);
      // dispatch(setSelectedData({ key: name, value: acceptedFile }));
      setIsUploading(true);
      if (extraction_required || verify) {
        // dispatch(setConfigLoading(true))
        dispatch(setUploadLoading(true));
        if (verify) {
          dispatch(setConfigLoadingText("Document validation is in process.."));
          setOcrMessage("Document validation is in process..");
        } else {
          dispatch(setConfigLoadingText("Data extraction is in process.."));
          setOcrMessage("Data extraction is in process..");
        }
      }

      dispatch(
        uploadUserDocument({
          acceptedFile,
          name: newName,
          userInfo,
          label,
          setSelectedData,
          verify,
          autofill,
          extraction_required,
          formErr,
          setFormErr,
          clearFieldError,
          docType,
          service_type,
          masking_required,
          selectedData,
          isRecursive,
          doc_number_validation,
        })
      )
        .unwrap()
        .then((res) => {
          setIsUploading(false);
          dispatch(setUploadLoading(false));
          if (res?.status === "success") {
            // dispatch(setConfigLoading(false))
            setOcrMessage(null);
            setUploaded(true);
            if (
              extraction_required ||
              verify ||
              res?.data?.responseData?.verification_response
            ) {
              dispatch(setConfigLoading(false));
              setOcrMessage(null);
              if (
                res?.data?.responseData?.verification_response?.error_code ==
                "dv-001"
              ) {
                setMessageToast({
                  type: "success",
                  msg: res?.data?.responseData?.verification_response
                    ?.extraction_error,
                });
              } else {
                if (res?.message) {
                  setMessageToast({ type: "success", msg: res?.message });
                } else {
                  setMessageToast({
                    type: "success",
                    msg: "File content extracted successfully",
                  });
                }
              }
              setTimeout(() => {
                setMessageToast(null);
              }, 2000);
            }
          } else {
            setUploaded(false);
            // dispatch(setConfigLoading(false))
            dispatch(setUploadLoading(false));
            setOcrMessage(null);
            if (res?.message) {
              setMessageToast({ type: "error", msg: res?.message });
            } else {
              setMessageToast({
                type: "error",
                msg: "Invalid file, Please upload a valid file",
              });
            }
            setTimeout(() => {
              setMessageToast(null);
            }, 2000);
          }
        })
        .catch((err) => {
          setIsUploading(false);
          // dispatch(setConfigLoading(false))
          dispatch(setUploadLoading(false));

          setOcrMessage(null);
          setMessageToast({ type: "error", msg: "Failed to upload file" });
          setTimeout(() => {
            setMessageToast(null);
          }, 3000);
        });
    },
    onDropRejected: (rejectedFiles) => {
      setUploaded(false);
      // dispatch(setConfigLoading(false))
      dispatch(setUploadLoading(false));
      setOcrMessage(null);
      setMessageToast({
        type: "error",
        msg: rejectedFiles[0].errors[0].message,
      });
      setTimeout(() => {
        setMessageToast(null);
      }, 3000);
    },
  });

  const acceptedFile = acceptedFiles.map((file) => {
    let fileData = {
      file: file,
      file_path: file.path,
      file_size: file.size,
    };
    return fileData;
  });

  const removeDocument = (name, documents) => {
    let newDoc = { ...documents };
    let newUploadedDocument = { ...uploadedDocuments };
    Object.keys(newDoc).forEach((key) => {
      if (name == key) delete newDoc[key];
    });
    if (isRecursive) {
      if (Object.keys(uploadedDocuments).length) {
        Object.keys(newUploadedDocument).forEach((key) => {
          if (recursive?.recursiveFormData[name]?.encrypted_filename == key)
            delete newUploadedDocument[key];
        });
        dispatch(setUploadedDocument(newUploadedDocument));
      }
    } else {
      if (Object.keys(uploadedDocuments).length) {
        Object.keys(newUploadedDocument).forEach((key) => {
          if (name == key) delete newUploadedDocument[key];
        });
        dispatch(setUploadedDocument(newUploadedDocument));
      }
    }
    dispatch(setFetchedDocument(newDoc));
  };

  const removeFiles = () => {

    if (isRecursive) {
      dispatch(
        setdeleteRecursiveDocument({
          key: newName,
          value: selectedData[newName],
        })
      );
    } else {
      dispatch(
        setdeleteDocument({ key: newName, value: selectedData[newName] })
      );
    }
    dispatch(clearSelectedDataKey({ key: newName }));
    dispatch(setSelectedData({ key: newName, value: null }));
    removeDocument(newName, documents);
    acceptedFiles.length = 0;
    acceptedFiles.splice(0, acceptedFiles.length);
    setFileName(null);
    setFileSize(null);
    setUploaded(false);
    setInvalidError(false);
  };

  const cancelClick = () => {
    removeFiles();
  };

  useEffect(() => {
    const uploadedFile = acceptedFile?.[0];
    if (uploadedFile) {
      const { file_path, file_size } = uploadedFile;
      setFileName(file_path);
      setFileSize(file_size);
    }
  }, [acceptedFile]);

  useEffect(() => {
    if (Object.keys(selectedData).includes(newName)) {
      setUploaded(true);
    }
    if (autofill) {
      dispatch(
        setMandatoryExtraction({ key: newName, value: extraction_required })
      );
    }
  }, []);

  useEffect(() => {
    if (isToggled && copiedData?.[newName] !== undefined) {
      dispatch(setDocuments({ key: newName, value: copiedData?.[newName] }));
      dispatch(deleteUploadedDocument({ key: newName }));
    }
    if (isAutofilled) {
      if (Object.keys(selectedData).includes(newName)) {
        setUploaded(true);
      }
    }
  }, [selectedData]);

  const [loading, setLoading] = useState(false);
  return (
    <>
      {loading && <LoadingSpinner />}
      <Label
        image={true}
        htmlFor="upload"
        label={label}
        tooltip={tooltip}
        validators={validators}
        digilocker={digilocker}
      />
      {/* <div className={size}> */}
      <>
        {!isUploading && !selectedData?.[newName] ? (
          <>
            {eval(liveness) ? (
              <LivenessCheck
                className={`${!isEditable && "radioDisabled"} ${
                  !error ? "file-uploader" : "file-uploader error"
                }`}
                setSelectedData={setSelectedData}
                userInfo={userInfo}
                clearFieldError={clearFieldError}
                label={label}
                isEditable={isEditable}
                uploaded={uploaded}
                setUploaded={setUploaded}
                name={newName}
                setFileName={setFileName}
                setFileSize={setFileSize}
                user_action={user_action}
                docType = {docType}
                random_generate = {random_generate}

              />
            ) : (
              ""
            )}
          </>
        ) : (
          <div className="file-uploaded">
            <VideoProgress
              fileName={selectedData[newName]?.original_name || fileName}
              fileSize={selectedData[newName]?.file_size || fileSize}
              uploaded={uploaded}
              cancelClick={cancelClick}
              removeFiles={removeFiles}
              error={invalidError}
              isEditable={isEditable}
              is_disabled={is_disabled}
              selectedData={selectedData}
              autofill={copiedData?.[newName] !== undefined}
              remove_disabled={orcMessage ? true : false}
              isDisabLed={isDisabLed}
              liveness={liveness}
              
            />
          </div>
        )}
      </>
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </>
  );
};

export default Liveness;
